import { isJP, isKR, isUS } from 'conf'

import Safebox from '@/assets/images/logo/icon-OfficePassword.svg'
import SafePassword from '@/assets/images/logo/icon-safePassword.svg'
import SafePasswordTextOnly from '@/assets/images/logo/icon-safepassword-text-only.svg'

const getCopyright = () => {
  if (isJP()) {
    return 'ⓒ JSecurity, Powered by JiranSoft'
  }
  return 'ⓒ JiranSoft'
}

export const SERVICE_COPYRIGHT = getCopyright()

const format = (jp, kr) => {
  if (isJP()) {
    return jp
  }
  if (isKR()) {
    return kr
  }

  if (isUS()) {
    return jp
  }

  return kr
}

const getName = () => {
  return format('service.password', 'service.password')
}

const getServiceNameTitle = () => {
  return format('service.safePassword', 'service.officePassword')
}

const getLogo = () => {
  return format(SafePassword, Safebox)
}

const getSettingLogo = () => {
  return format(SafePasswordTextOnly, Safebox)
}

const getTitle = () => {
  return format('SafePassword', 'OfficePassword')
}

const getMyRecordName = () => {
  return 'menu.record.myService'
}

const getUnReadyRegister = () => {
  return 'login.title.unReadyRegister'
}

const getUnReadyRegisterDesc = () => {
  return 'login.desc.unReadyRegisterService'
}

const getRegisterTitle = () => {
  return 'login.title.registerService'
}

const getSignupForTitle = () => {
  return 'login.title.signupForService'
}

const getNewSignupTitle = () => {
  return 'login.desc.newService'
}

const getSignInTitle = () => {
  return 'login.slogan.serviceSignIn'
}

const getLockBox = () => {
  return 'topBar.profileMenu.lockService'
}

export const SERVICE_NAME_TITLE = getServiceNameTitle()
export const SERVICE_NAME = getName()
export const SERVICE_LOGO_IMAGE = getLogo()
export const SETTING_SERVICE_LOGO_IMAGE = getSettingLogo()

export const SERVICE_MY_RECORD_NAME = getMyRecordName()
export const SERVICE_TITLE = getTitle()
export const SERVICE_UNREADY_REGISTER = getUnReadyRegister()
export const SERVICE_UNREADY_REGISTER_DESC = getUnReadyRegisterDesc()
export const SERVICE_REGISTER_TITLE = getRegisterTitle()
export const SERVICE_SIGNUP_FOR_TITLE = getSignupForTitle()
export const SERVICE_NEW_SIGNUP_TITLE = getNewSignupTitle()
export const SERVICE_SIGNIN_TITLE = getSignInTitle()
export const SERVICE_LOCK_BOX = getLockBox()
